import React from 'react'
import {createUseStyles} from 'react-jss'

import Layout from '../components/layouts/layout'
import SlackLink from '../components/slack-link'
import BasicPageHeading from '../components/basic-page-heading'
import playgroundLogo from '../../img/playground.svg'
import slackLogo from '../../img/slackLogoNew.png'
import docsLogo from '../../img/docs.svg'
import projectLibraryLogo from '../../img/project-library.svg'
import questionsLogo from '../../img/questions.svg'
import {combine} from '../styles/classname-utils'
import {brandBlack, brandWhite} from '../styles/brand-colors'
import {
  MOBILE_VIEW_OVERRIDE, TABLET_VIEW_OVERRIDE,
} from '../styles/constants'

const useStyles = createUseStyles({
  section: {
    textAlign: 'center',
  },
  subSection: {
    justifyContent: 'center',
    maxWidth: '84rem',
    margin: 'auto',
  },
  cardList: {
    gap: '2.5rem 3.5rem',
    [TABLET_VIEW_OVERRIDE]: {
      gap: '2.5rem',
    },
    [MOBILE_VIEW_OVERRIDE]: {
      gap: '1rem',
    },
  },
  card: {
    'backgroundColor': brandWhite,
    'boxShadow': `${brandBlack}40 0px 8px 24px`,
    'borderRadius': '4px',
    'padding': '1.5rem',
    'width': '22rem',
    'height': '18rem',
    'color': brandBlack,
    'textDecoration': 'none',
    '&:hover': {
      color: brandBlack,
      textDecoration: 'none',
      transform: 'scale(1.02)',
      transition: 'all 0.08s linear',
    },
    '& img': {
      height: '4.5rem',
      marginBottom: '0.5rem',
    },
    '& h2': {
      margin: '1.125rem',
    },
    '& p': {
      fontSize: '1.125rem',
      lineHeight: '1.6875rem',
      letterSpacing: '-0.2px',
    },
  },
})

export default () => {
  const classes = useStyles()
  return (
    <Layout title='Support'>
      <BasicPageHeading>
        Support
      </BasicPageHeading>
      <section className={combine('light', classes.section)}>
        <div className={combine('row', classes.subSection, classes.cardList)}>
          <a
            className={classes.card}
            href='/docs/web'
            target='_blank'
            rel='noopener noreferrer'
            a8='click;support;click-docs'
          >
            <img src={docsLogo} alt='docs logo' />
            <h2 className='font8-bold'>Docs</h2>
            <p className='font8-semibold'>
              Learn how to develop with 8th Wall and access detailed documentation
              for 8th Wall’s JavaScript API.
            </p>
          </a>

          <a
            className={classes.card}
            href='/8thwall'
            rel='noopener noreferrer'
            a8='click;support;click-project-library'
          >
            <img src={projectLibraryLogo} alt='project library logo' />
            <h2 className='font8-bold'>Project Library</h2>
            <p className='font8-semibold'>
              Get started with 8th Wall by viewing code
              and cloning sample projects from the 8th Wall Project Library.
            </p>
          </a>

          <a
            className={classes.card}
            href='/playground'
            rel='noopener noreferrer'
            a8='click;support;click-playground'
          >
            <img src={playgroundLogo} alt='playground logo' />
            <h2 className='font8-bold'>Playground</h2>
            <p className='font8-semibold'>
              Upskill your development and take your projects to the next level
              with advanced example projects.
            </p>
          </a>

          <SlackLink
            className={classes.card}
            a8='click;support;click-slack'
          >
            <img src={slackLogo} alt='slack logo' />
            <h2 className='font8-bold'>Slack</h2>
            <p className='font8-semibold'>
              Join our Slack channel to connect with fellow 8th Wall developers
              and get support from the community.
            </p>
          </SlackLink>

          <a
            className={classes.card}
            href='mailto:support@8thwall.com'
            target='_blank'
            rel='noopener noreferrer'
            a8='click;support;click-more-questions'
          >
            <img src={questionsLogo} alt='questions logo' />
            <h2 className='font8-bold'>Still have questions?</h2>
            <p className='font8-semibold'>
              Email support@8thwall.com to contact a member of our team
              and we will respond shortly.
            </p>
          </a>
        </div>

      </section>
    </Layout>
  )
}
